document.addEventListener("DOMContentLoaded", function() {
  const mainContent = document.getElementById('MainContent');

  if (!mainContent) {
    return;
  }
  let yotpoPaginationLoaded = false;
  let mobilePaginationLoaded = false;
  let retryCount = 0;
  const maxRetries = 20;  // Maximum number of retries before giving up

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (!yotpoPaginationLoaded) {
          const yotpoPaginationNav = mainContent.querySelector('.yotpo-reviews-pagination-container[role="navigation"]');
          if (yotpoPaginationNav) {
            yotpoPaginationNav.setAttribute('aria-label', 'Yotpo Reviews Pagination');
            yotpoPaginationLoaded = true;
          }
        }

        if (!mobilePaginationLoaded) {
          const mobilePaginationNav = mainContent.querySelector('.yotpo-pagination-container[role="navigation"]');
          if (mobilePaginationNav) {
            mobilePaginationNav.setAttribute('aria-label', 'Yotpo Reviews Pagination');
            mobilePaginationLoaded = true;
          }
        }

        // Clerk Links Accessibility
        const clerkLinks = mainContent.querySelectorAll('a[data-clerk-product-id]:not([aria-label])');
        clerkLinks.forEach(link => {
          const img = link.querySelector('img');
          const productTitle = link.getAttribute('href').split('/').pop().replace(/-/g, ' '); // Get the product name from the URL

          // Set aria-label based on product title
          if (productTitle) {
            link.setAttribute('aria-label', `View ${productTitle}`);
          }

          // Ensure the image also has an alt attribute
          if (img && !img.getAttribute('alt')) {
            img.setAttribute('alt', `${productTitle} product`);
          }
        });

        // If both elements are loaded or retries exceed max, stop observing
        retryCount++;
        if ((yotpoPaginationLoaded && mobilePaginationLoaded && clerkLinks.length === 0) || retryCount >= maxRetries) {
          observer.disconnect();
        }
    });
  });

  // Observe only changes to the #MainContent element and its children
  observer.observe(mainContent, { childList: true, subtree: true });
});